<template>
  <div v-rect-loading="loading" class="ads-tier-container">
    <div class="ads-tier-header">
      <div class="ads-tier-title">{{ $t(`${i18nPrefix}.title`) }}</div>
    </div>
    <div class="ads-tier-container">
      <div class="ads-tier-center">
        <div class="company-list company-list-1">
          <fieldset>
            <legend>{{ $t(`${i18nPrefix}.label.adsTierOne`) }}</legend>
            <div class="company-list-body-wrap">
              <draggable v-model="companyList1">
                <transition-group type="transition" name="flip-list">
                  <li v-for="(item, index) in companyList1" class="company-element" :key="item.id">
                    <el-image lazy class="img" :src="$DjangoMediaUrl(item.image)" :title="item.i18nName" />
                    <span class="company-element-order">{{ index + 1 }}</span>
                    <div v-auto-tooltip class="text">{{ item.i18nName }}</div>
                  </li>
                </transition-group>
              </draggable>
            </div>
          </fieldset>
        </div>
        <div class="company-list company-list-2">
          <fieldset>
            <legend>{{ $t(`${i18nPrefix}.label.adsTierTwo`) }}</legend>
            <div class="company-list-body-wrap">
              <ul class="company-list-body">
                <draggable v-model="companyList2">
                  <transition-group type="transition" name="flip-list">
                    <li v-for="(item, index) in companyList2" class="company-element" :key="item.id">
                      <el-image v-if="item.logo" lazy class="img" :src="$DjangoBaseUrl(item.logo)" :title="item.i18nName" />
                      <el-image v-else lazy class="img" :title="item.i18nName" />
                      <span class="company-element-order">{{ index + 1 }}</span>
                      <div v-auto-tooltip class="text">{{ item.i18nName }}</div>
                    </li>
                  </transition-group>
                </draggable>
              </ul>
            </div>
          </fieldset>
        </div>
        <div class="bottom-btn-group">
          <el-button class="save-btn" type="primary" @click="handleSave">{{ $t('common.btn.save') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { addI18nProperty } from '@/i18n'
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  data () {
    return {
      loading: false,
      i18nPrefix: 'admin.company.adsTierManagement',
      companyList1: [],
      companyList2: []
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('adsTier', ['getAdsTierInfo', 'saveAdsTierOrder']),
    async initPage () {
      this.loading = true
      try {
        const resp = await this.getAdsTierInfo()
        if (resp) {
          this.companyList1 = _.map(resp.company_list_1, item => addI18nProperty(item, 'i18nName', 'cn_name', 'name'))
          this.companyList2 = _.map(resp.company_list_2, item => addI18nProperty(item, 'i18nName', 'cn_name', 'name'))
        }
      } finally {
        this.loading = false
      }
    },
    async handleSave () {
      this.loading = true
      try {
        const params = {
          company_list_1: _.map(this.companyList1, (item, index) => ({
            id: item.id,
            orderValue: index
          })),
          company_list_2: _.map(this.companyList2, (item, index) => ({
            id: item.id,
            orderValue: index
          }))
        }
        await this.saveAdsTierOrder(params)
        this.$message({
          type: 'success',
          message: this.$t(`${this.i18nPrefix}.message.saveSuccess`)
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ads-tier-container {
  .ads-tier-header {
    display: flex;
    border-bottom: 1px solid #e4e7ed;
    .ads-tier-title {
      padding-top: 4px;
      padding-bottom: 18px;
      line-height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #303133;
    }
  }
  .ads-tier-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .ads-tier-center {
      width: 680px;
      li {
        display: inline-block;
        position: relative;
        margin: 5px;
      }
      .company-list {
        fieldset {
          margin: 25px 0;
          padding: 10px;
          border: 2px dotted #7c7a7a;
          legend {
            margin-left: 25px;
            padding: 0 5px;
            font-weight: bold;
            background-color: #fff;
          }
        }
      }
      .company-element {
        .img {
          margin: 10px 11px 5px 11px;
        }
        .text {
          margin: 0 auto;
          height: 20px;
          line-height: 20px;
          text-align: center;
          overflow-x: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          color: #666;
        }
        .company-element-order {
          background: #fff left bottom !important;
          border-radius: 0 16px 0 0;
          width: 22px;
          height: 20px;
          left: 11px;
          float: left;
          padding-left: 3px;
          padding-top: 2px;
          font-size: 15px;
          font-weight: bold;
          position: absolute;
        }
      }
      .company-list-1 {
        li {
          width: 154px;
          height: 145px;
          background: #fff;
          box-shadow: 2px 2px 0px rgba(0,0,0,0.15);
          border-radius: 8px;
          border: 2px solid #eee;
        }
        .img {
          width: 130px;
          height: 104px;
          display: inline-block;
        }
        .company-element-order {
          top: 94px;
        }
        .text {
          margin-top: -6px;
          width: 150px;
        }
      }
      .company-list-2 {
        li {
          width: 121px;
          height: 115px;
          background: #fff;
          box-shadow: 2px 2px 0px rgba(0,0,0,0.15);
          border-radius: 8px;
          border: 2px solid #eee;
        }
        .img {
          width: 97px;
          height: 74px;
          display: inline-block;
        }
        .company-element-order {
          top: 64px;
        }
        .text {
          margin-top: -3px;
          width: 119px;
        }
      }
      .bottom-btn-group {
        display: flex;
        justify-content: flex-end;
        .el-button {
          padding: 8px 28px;
          border-radius: 2px;
          line-height: 22px;
          font-size: 16px;
          font-weight: 500;
          color: #0096cc;
          &:last-child {
            margin-left: 24px;
            margin-right: 0;
            background: #0096cc;
            border-color: #0096cc;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>
